// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2gi5I","options":"AnswerScale_options__2adQ6","selected":"AnswerScale_selected__zmXF8"};